var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Box } from 'grommet/es6/components/Box';

import { StyledTdComponent } from '../StyledPagingTable';
import { extractTextProps } from './CellTextComponent';

export default (function (_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ['children']);

  var style = props.style,
      rest = _objectWithoutProperties(props, ['style']);

  var boxProps = _extends({ pad: 'small' }, extractTextProps(rest));
  return React.createElement(
    StyledTdComponent,
    { style: style, role: 'gridcell', align: 'center' },
    React.createElement(
      Box,
      _extends({ fill: true }, boxProps),
      children
    )
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/PagingTable/components/TdComponent.js
// module id = 1183
// module chunks = 0